module.exports = __webpack_public_path__ + "media/images/icons/fliist-e9c7057006b802cccb6d88b38525d112.svg";